import { FundingNotesTable } from './FundingNotesTable';

export default FundingNotesTable;
